/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'

function EditName(props) {
    const [show, setShow] = useState(false);
    // const [errors, setErrors] = useState({});
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            {/* <Button variant="primary" onClick={handleShow}>
                Launch static backdrop modal
            </Button> */}
            <Button variant="link" onClick={handleShow}>

                <h6 className="mb-0" style={{ "color": '#ff000' }}>Edit</h6>
            </Button>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Group Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <div className="d-flex">
                            <label htmlFor="roleName" className='font-weight-bolder'>Group Name <span className="text-danger">*</span></label>
                            {/* <label htmlFor="roleName" className="text-muted d-inline-flex ml-auto">({roleName.length}/100) Max 100 characters</label> */}
                        </div>

                        <input
                            type="text"
                            className="form-control"
                            id="InputRoleName"
                            name="roleName"
                            defaultValue={props.state.roleName}
                            required={true}
                            onChange={e => props.setName({ ...props.state, roleName : e.target.value})}
                            placeholder="Group Name"

                        // onChange={e => setRoleName(e.target.value)} aria-describedby="Title Name" 
                        />
                        <div className="invalid-feedback">
                            {/* {errors.roleName} */}
                        </div>
                        {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="hide-feature my-3 border mx-1" variant="outlined" >Cancle</Button>
                    <Button className="my-3 mx-1" variant="primary">Save</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default EditName